import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/hoavang.jpg'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "contact" }
const _hoisted_5 = { action: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Đăng nhập", -1)),
            _createVNode(_component_InputText, {
              id: "firstname",
              type: "text",
              modelValue: $setup.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
              placeholder: "Tên đăng nhập"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputText, {
              id: "lastname",
              type: "password",
              modelValue: $setup.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.doLogin()), ["enter"])),
              placeholder: "Mật khẩu"
            }, null, 8, ["modelValue"]),
            ($setup.valid)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Đăng nhập",
                  icon: "pi pi-sign-in",
                  iconPos: "left",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.doLogin()))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: "Đăng nhập",
                  icon: "pi pi-sign-in",
                  iconPos: "left",
                  disabled: "disabled"
                }))
          ])
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "right" }, [
        _createElementVNode("img", {
          class: "background",
          alt: "user header",
          src: _imports_0
        })
      ], -1))
    ])
  ]))
}